module.exports = __webpack_public_path__ + "img/emirates.73879eb5.png";